/**
 * Use Case: Get current theme preference
 */
export class GetThemeUseCase {
    constructor(preferencesRepository) {
        Object.defineProperty(this, "preferencesRepository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: preferencesRepository
        });
    }
    async execute() {
        return await this.preferencesRepository.getTheme();
    }
}
/**
 * Use Case: Update theme preference
 */
export class UpdateThemeUseCase {
    constructor(preferencesRepository) {
        Object.defineProperty(this, "preferencesRepository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: preferencesRepository
        });
    }
    async execute(theme) {
        await this.preferencesRepository.updateTheme(theme);
    }
}
